<template>
  <div>
    <v-tabs v-model="tab" fixed-tabs background-color="indigo" dark>
      <v-tab> ファイルアップロード </v-tab>
      <v-tab> アップロード済み </v-tab>
      <v-tab> 画像URL </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="scroll" style="height: 450px">
      <v-tab-item>
        <v-col class="px-8" align-content="center">
          <v-row>
            <v-col>
              <div>
                <v-text-field
                  v-model="fileName"
                  required
                  :rules="[presenceValidation]"
                >
                  <template v-slot:label>
                    <InputLabel label-name="ファイル名" :required="true" />
                  </template>
                </v-text-field>
              </div>
              <ImageFormAndThumbnail
                ref="imageFormAndThumbnail"
                labelName="ファイル"
                :requiredImageFile='true'
                @change-image-file="onFileChange"
              ></ImageFormAndThumbnail>

              <v-btn
                elevation="2"
                color="primary"
                :disabled="!fileName || !uploadImageFile"
                @click="uploadImage"
              >
                アップロード
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-tab-item>
      <v-tab-item>
        <v-row class="px-8" align-content="center">
          <WidgetUploadedImageSelecter @select-picture="selectPicture" />
        </v-row>
      </v-tab-item>
      <v-tab-item style='height: 100%'>
        <div
          class="justify-center flex-column"
          style="display: flex; height: inherit"
        >
          <v-row class="px-8 col ma-auto" align-content="center">
            <v-text-field
              v-model="imagePath"
              type="url"
              :rules="[presenceValidation, urlValidation]"
              label="画像URL"
            />
            <v-btn class='mt-3 ml-2' :disabled="!imagePath" @click="setImagePath"> 設定する </v-btn>
          </v-row>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import formValidationUtils from '@/mixins/form_validation_utils'
import InputLabel from '@/components/commons/formParts/inputLabel'
import WidgetUploadedImageSelecter from './WidgetUploadedImageSelecter'
import axios from 'axios'
import ImageFormAndThumbnail from './ImageFormAndThumbnail'

export default {
  components: {
    WidgetUploadedImageSelecter,
    InputLabel,
    ImageFormAndThumbnail
  },
  mixins: [formValidationUtils],
  data: function () {
    return {
      tab: null,
      fileName: '',
      pictures: [],
      imagePath: '',
      uploadImageFile: null,
      errorMessages: [],
      sizeValidation: (value) => {
        if (!value) {
          return '必ずファイルを入力してください'
        }
        if (value.size > 5000000) {
          return '画像サイズは5MB未満にして下さい'
        } else {
          return true
        }
      }
    }
  },
  methods: {
    onFileChange (file) {
      this.uploadImageFile = file
      this.fileName = file.name
    },
    uploadImage () {
      this.$store.dispatch('LoaderStore/displayLoader')
      let formData = new FormData()
      formData.append('attached_file[file]', this.uploadImageFile)
      formData.append('attached_file[name]', this.fileName)
      axios
        .post('/api/attached_files', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(({ data }) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const downloadImage = data.data.attributes
          this.$emit('set-picture-url', downloadImage.file.url)

          const payload = {
            status: 200,
            message: '画像をアップロードしました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.resetForm()
        })
        .catch((error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.message
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        })
        .finally(() => this.$store.dispatch('LoaderStore/hideLoader'))
    },
    selectPicture (picture) {
      this.$emit('set-picture-url', picture.file.url)
    },
    setImagePath () {
      this.$emit('set-picture-url', this.imagePath)
    },
    resetForm () {
      this.fileName = null
      this.uploadImageFile = null
      this.$refs.imageFormAndThumbnail.imageFile = null
      this.$refs.imageFormAndThumbnail.imagePreviewURL = null
      this.imagePath = null
    }
  }
}
</script>
<style scoped>
.scroll {
  overflow-y: auto;
}
</style>
